import * as React from "react";

export type ToolPanelVariant = "sidebar" | "drawer-content";

const ToolPanelVariantContext =
	React.createContext<ToolPanelVariant>("sidebar");

export interface ToolPanelVariantProviderProps {
	variant: ToolPanelVariant;
	children: React.ReactNode;
}

export function ToolPanelVariantProvider({
	variant,
	children,
}: ToolPanelVariantProviderProps): React.JSX.Element {
	return (
		<ToolPanelVariantContext.Provider value={variant}>
			{children}
		</ToolPanelVariantContext.Provider>
	);
}

export function useToolPanelVariant(): ToolPanelVariant {
	return React.useContext(ToolPanelVariantContext);
}
